import View from "../framework/view";
import {Order} from "../bo/order";
import template from "../../pugc/delivery-map";
import {MapView, PinConfig} from "./map";
import {isDelivery} from "../misc/orders";
import {plural} from "../misc/utils";
import {JsonDate} from "../misc/types";
import {DEFAULT_POS} from "./map_orders";
import {subscribe, Subscription} from "../resource_monitor";

export class DeliveryMapView extends View {

    static classname = "delivery-map-view";

    readonly dates : JsonDate[];

    private orders : Order[] = [];

    private map = new MapView();

    private statuses : { [status: string] : PinConfig | undefined } = {
        "Made": {
            background: "lightgreen",
            borderColor: "darkgreen",
            glyphColor: "darkgreen"
        },
        "Printed": {
            background: "yellow",
            borderColor: "orange",
            glyphColor: "orange"
        }
    };

    private subscription: Subscription | undefined = undefined;

    constructor(dates: JsonDate[]) {
        super(DeliveryMapView.classname);
        this.dates = dates;
        this.map.setPinFunction(order => {
            return this.statuses[order.currentStatus || ""]
        });
        this.listen();
    }

    async listen() {
        const opts = {deliveryDate: this.dates, deliveryDateNotNull: true};

        const listener = (orders: Order[]) => {
            this.refresh(orders);
            return {
                cancelListener: false
            }
        };

        this.subscription = subscribe(opts, listener, this.subscription);
    }

    refresh(orders?: Order[]) {
        if (orders) {
            const deliveries = orders.filter(isDelivery).filter(order => this.statuses[order.currentStatus || ""]);
            this.orders = deliveries;
        }
        this.map.setOrders(this.orders);
        this.update();
    }

    protected render0(): JQuery<HTMLElement> {

        const origin = DEFAULT_POS;
        const destination = DEFAULT_POS;

        const data = {
            orders: this.orders,
            map: this.map,
            origin: origin,
            destination: destination,
            plural: plural,
        };

        const out = this.pug(template, data);

        return out;
    }

}
